module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/contacts/icn_service-008fed15f46f464f66db380e2bc781fe.png";